<template>
    <div>
        <error-display v-if="this.has_error" :errors="this.errors"></error-display>
        <label class="checkbox">
            <input type="checkbox" v-model="viewer" @change="roleChanged('viewer')">
            Viewer
        </label>
        <label class="checkbox">
            <input type="checkbox" v-model="editor" @change="roleChanged('editor')">
            Editor
        </label>
        <label class="checkbox">
            <input type="checkbox" v-model="admin" @change="roleChanged('admin')">
            Site Admin
        </label>
    </div>
</template>

<script>
    import ErrorDisplay from "./ErrorDisplay";
    export default {
        name: "RoleDetail",
        components: {ErrorDisplay},
        props: {
            roles: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                viewer: null,
                editor: null,
                admin: null,
                location_id: '',
                user_id : ''
            }
        },
        mounted() {
            this.mapRoles();
        },
        watch : {
            roles : function(){
                this.mapRoles();
            }
        },
        methods: {
            mapRoles() {
                let viewer = false;
                let editor = false;
                let admin = false;
                let location_id = '';
                let user_id = '';
                this.roles.forEach(function (role) {
                    if (role.role_id == '1') {
                        viewer = true;
                    }
                    if (role.role_id == '2') {
                        editor = true;
                    }
                    if (role.role_id == '3') {
                        admin = true;
                    }
                    location_id = role.location_id;
                    user_id = role.user_id;
                })
                this.viewer = viewer;
                this.editor = editor;
                this.admin = admin;
                this.user_id = user_id;
                this.location_id = location_id;
                this.has_error = false;
                this.errors = [];
            },
            roleChanged(role){
                let action = '';

                let data = {data: {
                        location_id: this.location_id
                    }};

                switch (role) {
                    case 'viewer':
                        if(this.viewer === true)
                        {
                            action = 'add';
                            data.data.role_id = 1;
                        }
                        else
                        {
                            action = 'delete';
                            data.data.role_id = 1;
                        }
                        break;
                    case 'editor':
                        if(this.editor === true)
                        {
                            action = 'add';
                            data.data.role_id = 2;
                        }
                        else
                        {
                            action = 'delete';
                            data.data.role_id = 2;
                        }
                        break;
                    case 'admin':
                        if(this.admin === true)
                        {
                            action = 'add';
                            data.data.role_id = 3;
                        }
                        else
                        {
                            action = 'delete';
                            data.data.role_id = 3;
                        }
                        break;

                }
                if(action == 'add')
                {
                    let url = process.env.VUE_APP_API;
                    url = url + "/admin/users/" + this.user_id + "/roles"
                    this.$http.post(url,data)
                        .then(resp => {
                        })
                        .catch(err => {
                            this.has_error = true
                            this.errors = err.response.data.errors
                        })
                }

                if(action == 'delete')
                {
                    let url = process.env.VUE_APP_API;
                    url = url + "/admin/users/" + this.user_id + "/locations/" + data.data.location_id + "/roles/" + data.data.role_id;
                    this.$http.delete(url)
                        .then(resp => {
                        })
                        .catch(err => {
                            this.has_error = true
                            this.errors = err.response.data.errors
                        })
                }
            }
        }
    }
</script>

<style scoped>
label {
    padding: 15px;
}
</style>